import {ActionReducerMap} from '@ngrx/store';
import {AppState} from './app.state';
import {jfLibReducers} from '@adnova/jf-ng-components';


export const appReducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
};
